import { render, staticRenderFns } from "./TaxTypeSettings.vue?vue&type=template&id=6b9f9873"
import script from "./TaxTypeSettings.vue?vue&type=script&lang=ts"
export * from "./TaxTypeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports